import { render, staticRenderFns } from "./detailAllClientMsg.vue?vue&type=template&id=39a39d5f&scoped=true&"
import script from "./detailAllClientMsg.vue?vue&type=script&lang=js&"
export * from "./detailAllClientMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a39d5f",
  null
  
)

export default component.exports